/* eslint-disable */

import React from "react";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import { useEffect, useState } from "react";
import { fetchGraphQL } from "../../../services/api-raindrop.js";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import DateFormat from "../../../ui-components/date-format/date-format.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";
import { Link, useParams } from "react-router-dom";
import Currency from "../../../ui-components/currency/currency.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";

import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";

import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import OrganisationListElement from "../../../ui-components/organisation-list-element/organisation-list-element.tsx";

const ContributionLine = ({
  title,
  subunits,
  subunitsCurrency,
  organisationLogoUrl,
  charityNumber = "#346234",
  isBold = false,
}) => {
  const font = isBold ? "font-bold" : "font-normal";
  return (
    <div className={`flex flex-row w-full gap-2 ${font} items-center`}>
      {organisationLogoUrl && (
        <OrganisationLogo isSmall={true} src={organisationLogoUrl} />
      )}

      <div className="whitespace-nowrap">{title}</div>

      <Spacer />
      <Currency
        subunits={subunits}
        subunitsCurrency={subunitsCurrency}
        isStylised={isBold}
      />
    </div>
  );
};
const RaindropContributionInstance = ({ accountId }) => {
  const { accountPlanExecutionId } = useParams();

  const [accountPlanExecution, setAccountPlanExecution] = useState(null);

  useEffect(() => {
    fetchGraphQL(`
      query {
        accountPlanExecution(id: "${accountPlanExecutionId}") {
          id
          subunits
          subunitsFee
          subunitsRaindrop
          subunitsCurrency
          executedAt
          sausages {
            id
            subunits
            subunitsCurrency
            
            organisation {
              id
              name
            }
            waterfall {
              id
              title
            }
          }
        }
      }
      `).then((response) => {
      setAccountPlanExecution(response.data.accountPlanExecution);
    });
  }, [accountId, accountPlanExecutionId]);

  if (accountPlanExecution == null) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className={"flex flex-col h-full overflow-visible gap-4 pt-6 "}>
      <RaindropScrollContainer additionalClassNames="gap-7">
        <div className="flex flex-row w-full">
          <RaindropButton
            title="Back"
            icon="fa-chevron-left"
            style={ButtonStyle.Secondary}
            to="/raindrop/settings/contributions"
          />
        </div>

        <RaindropCard>
          <RaindropTitle style={ButtonStyle.Primary} />

          <RaindropTextSubtitle isCentered={true}>
            <DateFormat dateIsoString={accountPlanExecution.executedAt} />
          </RaindropTextSubtitle>

          <RaindropDivider />
          <div className="flex flex-row w-full">
            <div className="whitespace-nowrap">The Raindrop Company</div>
            <Spacer />
            <Currency
              subunits={accountPlanExecution.subunitsRaindrop}
              subunitsCurrency={accountPlanExecution.subunitsCurrency}
            />
          </div>
          <div className="flex flex-row w-full">
            <div className="whitespace-nowrap">Payment Provider</div>
            <Spacer />
            <Currency
              subunits={accountPlanExecution.subunitsFee}
              subunitsCurrency={accountPlanExecution.subunitsCurrency}
            />
          </div>
          {accountPlanExecution.sausages.map((sausage) => (
            <ContributionLine
              key={sausage.id}
              title={sausage.organisation?.name || sausage.waterfall?.title}
              subunits={sausage.subunits}
              subunitsCurrency={sausage.subunitsCurrency}
            />
          ))}
          <RaindropDivider />

          <ContributionLine
            title={"Total"}
            subunits={accountPlanExecution.subunits}
            isBold={true}
          />
        </RaindropCard>
      </RaindropScrollContainer>
    </div>
  );
};

export default RaindropContributionInstance;
